import React from "react";
import { Button } from "@mui/material";
import { IRoleBasedSecurityButtonProps } from "./RoleBasedSecurityButton.types";
import { useRoles } from "../../RolesProvider/RolesProvider";
import { usePremissions } from "../../PremissionsProvider/PremissionsProvider";

export const RoleBasedSecurityButton: React.FC<IRoleBasedSecurityButtonProps> = (
  props,
) => {
  const {
    editAccess,
    moduleId,
    moduleIds,
    allowFullAccess,
    children,
    ...buttonProps
  } = props;

  const { roles } = useRoles();
  const { getPremissionsByModuleId } = usePremissions();

  const isAllowed = React.useMemo(() => {
    // 1. If allowFullAccess is set to true, allow access unconditionally
    if (allowFullAccess) {
      return true;
    }

    // 2. If explicit editAccess is provided, respect boolean / numeric flag
    if (editAccess !== undefined) {
      return editAccess === 1 || editAccess === true;
    }

    // Collect module IDs to check
    const targetModuleIds: string[] = [
      ...(moduleIds || []),
      ...(moduleId ? [moduleId] : []),
    ];

    if (targetModuleIds.length === 0) {
      return true;
    }

    const accessibleModuleIds = (roles || [])
      .filter((module) => module.show_module === 1)
      .map((module) => module.module_key || module.table_name);

    return targetModuleIds.some((id) => {
      if (accessibleModuleIds.includes(id)) {
        return true;
      }
      const perm = getPremissionsByModuleId(id) as any;
      return perm?.show_module === 1 || perm?.edit_access === 1;
    });
  }, [
    allowFullAccess,
    editAccess,
    moduleId,
    moduleIds,
    roles,
    getPremissionsByModuleId,
  ]);

  if (!isAllowed) {
    return null;
  }

  return <Button {...buttonProps}>{children}</Button>;
};
